
import { ChevronLeft, RefreshCw, X, Edit2, ChevronRight, ChevronDown, ChevronUp } from 'lucide-react';
import './amount-entry.css';
import InnerHeader from '../../components/InnerHeader';
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
export default function LocalDepositAmount({ items, userData, transactionData, hasEWallet, general }) {

  const [isReminderOpen, setIsReminderOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [activeAmount, setActiveAmount] = useState("");
  const [icon, setIcons] = useState('');
  const [selectedAccount, setSelectedAccount] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  // Removed unused state variable to avoid confusion
  const [numbers, setNumbers] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const remoteId = localStorage.getItem('remote_id');
  const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "500"];
  const firstItem = items.find(item => item.status === "active");
  const [pgs, setPgs] = useState([]);
  const [name, setName] = useState('');


  useEffect(() => {
    const uniquePaymentMethods = [];
    const seenNames = new Set();
    items.forEach((item) => {
      if (item.name && !seenNames.has(item.name.toLowerCase())) {
        seenNames.add(item.name.toLowerCase());
        uniquePaymentMethods.push(item);
      }
    });
    if (Number(general?.withdrawal_status) === 0) {
      setPgs([]);
    } else {
      setPgs(uniquePaymentMethods);
    }

  }, [items]);

  useEffect(() => {
    setName(firstItem?.name);
  }, [firstItem]);

  // console.log(`Selector method: ${firstItem?.name}`);
  // console.log(`Selector method XX:`, items);

  const [getotherContracts, setOtherContracts] = useState([]);

  // const fetchOther = async () => {
  // 	const token = localStorage.getItem('token');
  // 	if (token) {
  // 		try {
  // 			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
  // 				method: 'GET',
  // 				headers: {
  // 					'Authorization': `Bearer ${token}`,
  // 				},
  // 			});

  // 			if (response.ok) {
  // 				const data = await response.json();
  // 				setOtherContracts(data.data || []);
  // 				console.log(data.data);

  // 			} else {
  // 				console.error('Failed to fetch user data');
  // 			}
  // 		} catch (error) {
  // 			console.error('Error fetching user data:', error);
  // 		}
  // 	}
  // };

  // useEffect(() => { 
  // 	fetchOther();
  // }, []);

  const handleItemClick = (id, icon, name,item) => {
    setActiveItem(id);
    setIcons(icon);
    setName(name);
    
  };
  // Fetch other contracts

  useEffect(() => {
    fetchOtherContracts();
    if (firstItem) {
      setActiveItem(firstItem.id);
      setIcons(firstItem.icon);
    }
    console.log(firstItem);
  }, []);

  // Set default selected account when data is available


  const fetchOtherContracts = async () => {
    if (token) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          // Filter contracts where isverify is 1
          // let verifiedContracts = (data.data || []).filter(contract => contract.isverify === 1);
          // if (userData?.session_id == 1) { 
          // 	verifiedContracts.push(userData?.phone);
          // }
          // Removed unused setter call for clarity
          let numbers = [];
          if (userData?.session_id == 1 && userData?.phone) {
            numbers.push(userData?.phone);
          }
          // if (userData?.session_id == '1') {
          // 	data.push(userData?.phone);
          // }
          if (data?.data && data?.data.length > 0) {
            data.data.forEach((item) => {
              if (item.isverify) {
                numbers.push(item.contract_value);
              }
            });
          }
          setNumbers(numbers);
          if (numbers.length > 0) {
            console.log("Selected account:", numbers, numbers[0]);
            setSelectedAccount(numbers[0]);
          }
        } else {
          console.error("Failed to fetch contracts");
        }
      } catch (error) {
        console.error("Error fetching contracts:", error);
      }
    }
  };



  const handleSelection = (value) => {
    setSelectedAccount(value);
    console.log(value);
  };

  const handleAmountClick = (amount) => {
    setActiveAmount(amount);
  };
  const checkUserEligibility = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/userwithdrawcheck?remote_id=${remoteId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();
      console.log('API response data:', data);

      if (!response.ok) {
        if (response.status === 400) {
          if (data.error.match(/Date of Birth/i)) {
            setModalMessage(`<a href="/profile">${data.error}</a>`);
          } else {
            setModalMessage(data.error || '<a href="/turnover-record">Please complete your turnover and try again.</a>');
          }
          setShowModal(true);
          return false;
        } else {
          setModalMessage(data.error || 'An error occurred.');
          setShowModal(true);
          return false;
        }
      }

      if (data.success) {
        // User is eligible for withdrawal
        return true;
      } else {
        // Fallback for other cases
        setModalMessage('An unknown error occurred.');
        setShowModal(true);
        return false;
      }
    } catch (error) {
      return false;
    }
  };


  const handleSubmit = async () => {

    // let isVerified = (userData?.session_id == '1') ? true : false;
    // if (!isVerified) {
    //   if (getotherContracts && getotherContracts.length > 0) {
    //     isVerified = getotherContracts.some(contract => contract.isverify === 1);
    //   }
    //   if (!isVerified) {
    //     setModalMessage(`<a href="/profile">Please verify your phone number first.</a>`);
    //     setShowModal(true);
    //     return;
    //   }
    // }

    // if (transactionData && transactionData.length > 0) {
    //   for (let trns of transactionData) {
    //     if (trns.action == "withdraw" && trns.key === "0") {
    //       setModalMessage(`You already have a withdraw request pending. Please wait for it to be processed before making another withdraw request.`);
    //       setShowModal(true);
    //       return;
    //     }
    //   }
    // }


    if (!activeAmount) {
      setModalMessage("Amount is required.");
      setShowModal(true);
      return;
    }

    // if (!selectedAccount) {
    //   setModalMessage("Account number is required.");
    //   setShowModal(true);
    //   return;
    // }


    if (!activeItem) {
      setModalMessage("Please select your payment method.");
      setShowModal(true);
      return;
    }

    // Check user eligibility
    const eligible = await checkUserEligibility();
    if (!eligible) {
      return;
    }

    setSubmitLoading(true);

    const remoteId = localStorage.getItem("remote_id");

    const requestBody = {
      remote_id: remoteId,
      account_number: selectedAccount || '12345678',
      amount: activeAmount,
      payment_id: hasEWallet ? 0 : activeItem,
      provider: hasEWallet ? name : name,
    };
    console.log("adsd", requestBody);

    console.log(requestBody);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/submit-withdraw`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setModalMessage(errorData.error);
        setShowModal(true);
        return;
      }

      const data = await response.json();

      if (data.success) {
        setModalMessage("Withdrawal successful!");
        setShowModal(true);
        navigate("/payment-request", {
          state: {
            amount: activeAmount,
            payment_icon: icon,
          },
        });
      } else {
        setModalMessage(data.message);
        setShowModal(true);
      }
    } catch (error) {
      setModalMessage("An error occurred. Please try again.");
      setShowModal(true);
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div className="amount-container">
      {/* Header */}
      <InnerHeader title="Enter the amount" />
      {/* <div className="amount-header">
        <button className="back-btn">
          <ChevronLeft size={24} />
        </button>
        <h1>Enter the amount</h1>
      </div> */}

      {/* Main Content */}
      <div className="amount-content">
        {/* Wallet Balance */}
        <div className="wallet-section">
          <div className="wallet-info">
            <span className="wallet-label-pf">Main wallet</span>
            <div className="balance-display">
              <span className="currency-icon">৳</span>
              <span className="balance-amount-pf">{userData?.balance || 0}</span>
              <button className="refresh-btn">
                <RefreshCw size={18} />
              </button>
            </div>
          </div>
          <div className="available-balance-pf">
            Available balance ৳ 500.00 - ৳ 10,000.00
          </div>
        </div>

        {/* Amount Input */}
        <div className="form-group">
          {/* <label className="form-label">Enter amount</label> */}
          <input
            type="number"
            name="amount"
            className="form-input vs"
            value={activeAmount}
            onChange={(e) => setActiveAmount(e.target.value)}
            placeholder="Enter amount BDT"
          />
          {/* {currency === '$' && <div style={{ fontSize: "14px", marginTop: '10px', textAlign: 'center' }}>1 USDT = {usdtRate} BDT/TK</div>} */}
        </div>

        {/* Payment Method */}
        <div>
          <label
            className="section-title"
            onClick={() => navigate("/transaction-progress")}
          >
            Select payment
          </label>
          <div className="payment-methods">
            {pgs.map((method) => (
              <div
                className={`card-qd payment-method ${name === method.name ? "active" : ""}`}

                key={method.id}
                onClick={() => handleItemClick(method.id, method.icon, method.name,method)}

              // checked={paymentMethod?.name === method.name}
              >

                <div className="logo-box">
                  <img
                    alt={method.name}
                    src={`${process.env.REACT_APP_API_URL}/storage/${method.icon}`}
                    loading="lazy"
                  />
                </div>

                <div className="title-qd">{method.name}</div>
              </div>

            ))}
          </div>
        </div>


        {/* Info Section */}
        <div className="section-container">
          <div className="section-label">Info</div>
          {/* {numbers.length > 0 &&
							numbers.map((contract, index) => ( */}
          <div

            className="info-card"
          >
            <div className="phone-info">
              <div className="phone-indicator"></div>
              <span className="phone-number">{userData?.phone || ""}</span>
            </div>
            <ChevronRight size={20} className="chevron-icon" />
          </div>
          {/* ))} */}
        </div>



        {/* Submit Button */}
        <button onClick={handleSubmit}
          disabled={submitLoading || pgs.length === 0} className="submit-btn">Submit</button>
      </div>
    </div>
  );
}
